import React from 'react';

import LivePage from './LivePage';
import submenuTests from './menus/submenu-tests';

import ImageTopSimilarityFinder from '../components/images/ImageTopSimilarityFinder';


export default class TestImageEmbedSimilarity extends LivePage {
  constructor(props) {
    super(props);

    this.fullScreen = true;
    
    this.submenu = submenuTests;
  }

  renderPageBody() {
    return <ImageTopSimilarityFinder
      imgId={this.getUrlParam('imgId') || ''}
      setup={this.getUrlParam('setup') || ''}
      onSourceChange={imgId => this.setUrlParams({ imgId })}
      onSetupChange={setup => this.setUrlParams({ setup })}
    />;
  }
}
